export default "<process-heading [departmentId]='deptId' [processId]='processId' [type]=\"'analytics'\"></process-heading>"